import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { RendererExtensionHandlerProps } from '../src/ExcerptExtensionHandler.tsx';

export const ExcerptExtensionHandler: LoadableType<RendererExtensionHandlerProps> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-ExcerptExtensionHandler" */ '../src/ExcerptExtensionHandler.tsx'
				)
			).ExcerptExtensionHandler,
	});
